import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LandedCost, LandedCostCreate, LandedCostFilter } from '../data/landedCost';

export function createLandedCostService(client: AxiosInstance) {
  return createCrudService<LandedCost, LandedCostCreate, LandedCostFilter>(
    client,
    '/purchase/LandedCost',
    'id',
  );
}

export type LandedCostService = CrudService<LandedCost, LandedCostCreate, LandedCostFilter>;
